import { ExternalLink, LogOut, Bug, LayoutGrid } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export function AppHeader({ onGoProjects, onOpenDiagnostics, onLogout }) {
  return (
    <header className="sticky top-0 z-40 border-b border-re-line bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-2 px-3 py-3.5 sm:px-5">
        <button type="button" onClick={onGoProjects} className="flex shrink-0 items-center gap-2 whitespace-nowrap" data-testid="header-home">
          <Logo variant="light" emblemY={7} />
          <span className="hidden rounded-full border border-re-line px-2.5 py-1 text-xs font-medium text-re-muted lg:inline">Video Creator</span>
        </button>
        <nav className="flex shrink-0 items-center gap-1">
          <Button variant="ghost" size="sm" onClick={onGoProjects} data-testid="nav-projects" className="px-2 text-re-charcoal sm:px-3">
            <LayoutGrid className="h-4 w-4 sm:mr-1.5" /> <span className="hidden md:inline">Projecten</span>
          </Button>
          <a href="/" data-testid="nav-website">
            <Button variant="ghost" size="sm" className="px-2 text-re-muted sm:px-3"><ExternalLink className="h-4 w-4 sm:mr-1.5" /> <span className="hidden md:inline">Naar website</span></Button>
          </a>
          <Button variant="ghost" size="sm" onClick={onOpenDiagnostics} data-testid="nav-diagnostics" className="px-2 text-re-muted sm:px-3">
            <Bug className="h-4 w-4 sm:mr-1.5" /> <span className="hidden md:inline">Owner</span>
          </Button>
          <Button variant="outline" size="sm" onClick={onLogout} data-testid="nav-logout" className="rounded-full px-2 sm:px-3">
            <LogOut className="h-4 w-4 sm:mr-1.5" /> <span className="hidden md:inline">Uitloggen</span>
          </Button>
        </nav>
      </div>
    </header>
  );
}
